import { useExchangeStore } from '@/stores/exchange';

export function handlePositionUpdate(positionUpdateObject) {
  const exchangeStore = useExchangeStore();

  if (
    positionUpdateObject &&
    positionUpdateObject.renderedGame &&
    positionUpdateObject.renderedGame.id
  ) {
    // Keep userOrders current on every view (homepage included): the
    // aggregate price feed carries no per-order ownership, so own-order
    // highlighting depends on this store being up to date everywhere.
    const oldPosition = exchangeStore.userOrders.find(
      (o) => o.renderedGame.id === positionUpdateObject.renderedGame.id,
    );
    if (oldPosition) {
      const index = exchangeStore.userOrders.indexOf(oldPosition);
      if (index !== -1) {
        exchangeStore.userOrders.splice(index, 1, positionUpdateObject);
      }
    } else {
      exchangeStore.userOrders.push(positionUpdateObject);
    }
    // Stamp the game so a reseed whose HTTP request predates this update
    // leaves it alone (see reseedUserOrders).
    exchangeStore.markUserOrdersLiveUpdate(
      positionUpdateObject.renderedGame.id,
    );
    exchangeStore.refreshAggregateOwnershipForGame(
      positionUpdateObject.renderedGame.id,
    );

    // SingleGame View
    if (exchangeStore.singleGameOrExchange === 'singleGame') {
      const orderSummarySingleGameNew = JSON.parse(
        JSON.stringify(exchangeStore.singleGame.orderSummary),
      );

      const matchedGame = exchangeStore.singleGame.games.find(
        (g) => g.id === positionUpdateObject.renderedGame.id,
      );

      if (matchedGame) {
        // Find the index of the game that needs updating
        const updateIndex = orderSummarySingleGameNew.findIndex(
          (o) => o.renderedGame.id === positionUpdateObject.renderedGame.id,
        );

        if (updateIndex !== -1) {
          // If the game exists, replace it with the updated object
          orderSummarySingleGameNew.splice(
            updateIndex,
            1,
            positionUpdateObject,
          );
        } else {
          // If the game doesn't exist, add the new game
          orderSummarySingleGameNew.push(positionUpdateObject);
        }
        exchangeStore.setSingleGameOrderSummary(orderSummarySingleGameNew);
      }
      /////POSITION UPDATE OUTSIDE OF EXCHANGE AND SPORTSBOOK
    } else if (exchangeStore.singleGameOrExchange === 'exchange') {
      const gameIndex = exchangeStore.games.findIndex(
        (game) => game.id === positionUpdateObject.renderedGame.id,
      );
      if (gameIndex !== -1) {
        const updatedGame = { ...exchangeStore.games[gameIndex] };
        updatedGame.position = positionUpdateObject.renderedGame.position;
        exchangeStore.games.splice(gameIndex, 1, updatedGame);
      }
    }
  }
}
